"use client";

import { useInfront } from "@/context/infront-context";
import { useEffect } from "react";

type SingleValueProps = {
  id: string;
  feed: number;
  ticker: string;
};

const SingleValue = (props: SingleValueProps) => {
  const { isReady, load } = useInfront();

  useEffect(() => {
    let widget: any;

    load?.(["core"]).then(() => {
      if (!isReady) return;

      const widgetOptions =
        new window.Infront.InstrumentSingleValueWidgetOptions();

      widgetOptions.rootElement = "span";
      widgetOptions.name = "PCT_CHANGE";
      widgetOptions.enableChangeStatusColors = true;
      widgetOptions.instrument = new window.Infront.Instrument(
        props.feed,
        props.ticker
      );

      widget = window.infront.instrumentSingleValueWidget(
        `#${props.id}`,
        widgetOptions
      );
    });

    return () => {
      widget?.destroy?.();
    };
  }, [isReady, props.ticker, props.feed, props.id]);

  return <span className="single-value" id={props.id} />;
};

export default SingleValue;
